import type { Component } from 'vue';

import { authRoutes } from './auth';

import { administrationRoutes } from './administration';
import { digitalSignageRoutes } from './digitalSignage';
import { homeRoutes } from './home';
import { liveRoutes } from './live';
import { meRoutes } from './me';
import { schedulingRoutes } from './scheduling';
import { soundscapeRoutes } from './soundscape';

export const routes = [{
	path: '/auth',
	children: authRoutes
}, {
	path: '/app',
	name: 'root',
	component: (): Component => import('../App.vue'),
	children: [{
		path: ':organizationId',
		children: [
			...administrationRoutes,
			...digitalSignageRoutes,
			...homeRoutes,
			...liveRoutes,
			...meRoutes,
			...schedulingRoutes,
			...soundscapeRoutes
		]
	}]
}, {
	path: '/:pathMatch(.*)*',
	redirect: '/auth/login'
}];